import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';

import Const from '../../util/Constants';
import Util from "../../util/Util";
import withRouter from '../../util/WithRouter';
import LeadAPI from '../../api/LeadAPI';
import ApiUiController from '../../controller/ApiUiController';
import ViewController from "../../controller/ViewController";
import LeadConst from '../../util/LeadConst';

class LeadNextPrev extends React.Component {

  constructor(props) {
    super(props);

    this.iItem = parseInt(props.match.params.indx);
    this.direction = parseInt(props.match.params.direction);

    const cView = reactLocalStorage.getObject(Const.CurrentViews);
    const modelfields = reactLocalStorage.getObject(Const.FieldList);
    const views = ViewController.getViews(Const.Lead);
    this.view = views.find(view => view.id === (cView.lead ? cView.lead : 0));
    if(!this.view) {
      this.view = this.views.find(view => view.id === 0);
    }
    this.list = modelfields.lead.find(list => list.view === this.view.id);

    this.iItem = this.direction === LeadConst.Next ? this.iItem + 1 : this.iItem - 1;
    this.index = this.iItem % this.list.pagination.perPage;
    if(this.index === 0 && this.direction === LeadConst.Next) {
      this.list.pagination.currentPage = this.list.pagination.currentPage + 1;
    } else if (this.index === this.list.pagination.perPage - 1 && this.direction === LeadConst.Previous) {
      this.list.pagination.currentPage = this.list.pagination.currentPage - 1;
    }

    const models = reactLocalStorage.getObject(Const.Model);
    this.Restrict = Util.isAllow(models.lead.permission, Const.PermRestricAcc);

    reactLocalStorage.setObject(Const.FieldList, modelfields);
    this.state = { inApiCall: true };
  }

  componentDidMount() { this.loadLeads(); }
  loadLeads = () => {
    const mainFilters = ViewController.getRestrictionsView(Const.Lead);
    const filters = ViewController.filters([...this.list.filters], this.view.filters, mainFilters, this.Restrict);
    this.setState({ ...this.state, inApiCall: true, popup: '' });
    LeadAPI.list({ ...this.list, filters }, this.onReceived, this.onFail);
  }
  onFail = res => this.setState({ ...this.state, inApiCall: false });
  onReceived = res => this.props.navigate(`/lead/preview/${res.data[this.index].id}?indx=${this.iItem + 1}&size=${res.count}`);

  render() {
    return (
      <ApiUiController inApiCall={this.state.inApiCall}><div /></ApiUiController>
    );
  }
}
export default withRouter(LeadNextPrev);